// extracted by mini-css-extract-plugin
export default {"body":"Footer_body__6QR4f","middle":"Footer_middle__PGY0y"};